import {
    BOT_OPS_KILL_URL,
    BOT_OPS_INBOX_KILLS_URL,
    BOT_OPS_INBOX_KILL_URL,
    BOT_OPS_SANDBOX_KILL_URL,
    BOT_OPS_SANDBOX_MODEL_URL,
    BOT_OPS_MODELS_CATALOG_URL,
    BOT_OPS_CONFIG_URL,
    BOT_OPS_CONFIG_REAPPLY_URL,
    BOT_OPS_CONFIG_SUGGEST_URL,
    BOT_OPS_CONFIG_SUGGEST_MODELS_URL,
    botOpsConfigSuggestJobUrl,
    BOT_OPS_HEALTH_URL,
    BOT_OPS_CHANNELS_URL,
    BOT_OPS_SANDBOX_SESSION_URL,
    BOT_OPS_SANDBOX_SESSION_RESET_URL,
    BOT_OPS_SANDBOX_MESSAGES_URL,
    BOT_OPS_SANDBOX_TRACE_URL,
    BOT_OPS_PROMPTFOO_SUITE_URL,
    BOT_OPS_PROMPTFOO_ASSERTS_URL,
    BOT_OPS_PROMPTFOO_MODELS_URL,
    BOT_OPS_PROMPTFOO_RUNS_URL,
} from "../../context/paths";
import {
    getOrCreateSandboxClientKey,
    SANDBOX_CLIENT_KEY_HEADER,
} from "./sandboxClientKey";

const authHeaders = (token) => ({
    "Content-Type": "application/json",
    "authorization": `Bearer ${token}`,
});

/** Auth + chave de isolamento por aba do chat sandbox. */
const sandboxHeaders = (token) => ({
    ...authHeaders(token),
    [SANDBOX_CLIENT_KEY_HEADER]: getOrCreateSandboxClientKey(),
});

export const getKill = async (token) => {
    try {
        const response = await fetch(BOT_OPS_KILL_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const setKill = async (token, enabled, reason = "") => {
    try {
        const response = await fetch(BOT_OPS_KILL_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({ enabled, reason }),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao atualizar kill switch",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getInboxKills = async (token) => {
    try {
        const response = await fetch(BOT_OPS_INBOX_KILLS_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const setInboxKill = async (token, inboxId, enabled, reason = "") => {
    try {
        const response = await fetch(BOT_OPS_INBOX_KILL_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({ inbox_id: inboxId, enabled, reason }),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao atualizar bot da inbox",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getSandboxKill = async (token) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_KILL_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const setSandboxKill = async (token, enabled, reason = "") => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_KILL_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({ enabled, reason }),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao atualizar kill do sandbox",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getSandboxModel = async (token) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_MODEL_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler modelo do sandbox",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const putSandboxModel = async (token, { modelo, temperatura }) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_MODEL_URL, {
            method: "PUT",
            headers: authHeaders(token),
            body: JSON.stringify({
                modelo: typeof modelo === "string" ? modelo.trim() : (modelo ?? ""),
                temperatura: serializarTemperatura(temperatura),
            }),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao salvar modelo do sandbox",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getModelsCatalog = async (token) => {
    try {
        const response = await fetch(BOT_OPS_MODELS_CATALOG_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao carregar catálogo de modelos",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getConfig = async (token) => {
    try {
        const response = await fetch(BOT_OPS_CONFIG_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler configuração",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getConfigById = async (token, id) => {
    try {
        const response = await fetch(`${BOT_OPS_CONFIG_URL}/${id}`, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler versão",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const listChannels = async (token) => {
    try {
        const response = await fetch(BOT_OPS_CHANNELS_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao listar canais",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const createChannel = async (token, name) => {
    try {
        const response = await fetch(BOT_OPS_CHANNELS_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({ name }),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao criar canal",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getChannelStatus = async (token, name) => {
    try {
        const response = await fetch(
            `${BOT_OPS_CHANNELS_URL}/${encodeURIComponent(name)}/status`,
            {
                method: "GET",
                headers: authHeaders(token),
            }
        );
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao consultar status",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getChannelQr = async (token, name) => {
    try {
        const response = await fetch(
            `${BOT_OPS_CHANNELS_URL}/${encodeURIComponent(name)}/qr`,
            {
                method: "GET",
                headers: authHeaders(token),
            }
        );
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao obter QR",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const logoutChannel = async (token, name) => {
    try {
        const response = await fetch(
            `${BOT_OPS_CHANNELS_URL}/${encodeURIComponent(name)}/logout`,
            {
                method: "POST",
                headers: authHeaders(token),
                body: "{}",
            }
        );
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao desconectar canal",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const saveConfig = async (token, { system_prompt, guardrails, knowledge, modelo, temperatura }) => {
    try {
        // Temperatura precisa ir como número: o lint do backend rejeita string
        // (inclusive "0.3" de <input type="number">) e campo vazio tem que ser
        // null, não "", para cair no padrão do sistema.
        const body = {
            system_prompt,
            guardrails,
            knowledge,
            modelo: typeof modelo === "string" ? modelo.trim() : (modelo ?? ""),
            temperatura: serializarTemperatura(temperatura),
        };
        const response = await fetch(BOT_OPS_CONFIG_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: formatBotOpsConfigError(data, "Erro ao salvar configuração"),
                errors: data.errors,
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

/** Junta message + errors[] do lint (L1–L7) numa string legível no toast. */
export function formatBotOpsConfigError(data, fallback = "Erro na configuração") {
    const base = data?.message || data?.error || fallback;
    const errors = Array.isArray(data?.errors) ? data.errors : [];
    if (errors.length === 0) return base;
    const detail = errors
        .slice(0, 6)
        .map((e) => `${e.code || "?"} ${e.field || ""}: ${e.detail || ""}`.trim())
        .join(" · ");
    const more = errors.length > 6 ? ` (+${errors.length - 6})` : "";
    return `${base} — ${detail}${more}`;
}

/**
 * Converte o valor do formulário para o que o backend espera.
 * Vazio → null (usar padrão). Número ou string numérica → Number.
 */
export function serializarTemperatura(valor) {
    if (valor == null || valor === "") return null;
    const n = typeof valor === "number" ? valor : Number(valor);
    return Number.isFinite(n) ? n : null;
}

export const getHealth = async (token) => {
    try {
        const response = await fetch(BOT_OPS_HEALTH_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao consultar saúde do bot-ops",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const reapplyConfig = async (token) => {
    try {
        const response = await fetch(BOT_OPS_CONFIG_REAPPLY_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({}),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao reaplicar configuração",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const suggestFetchErrorMessage = (error) => {
    const raw = error?.message || String(error || "");
    if (/aborted|aborterror|the operation was aborted/i.test(raw)) {
        return "A API demorou demais para responder. Tente de novo.";
    }
    if (/failed to fetch|networkerror|load failed/i.test(raw)) {
        return "Falha de rede ao falar com a API (api.mgs.cards). Tente de novo — se repetir, o proxy pode ter cortado a requisição.";
    }
    return raw || "Erro ao pedir sugestões de configuração";
};

/** Timeout padrão dos polls de sandbox/trilha — request pendurada congela o loop. */
export const SANDBOX_POLL_TIMEOUT_MS = 12000;

/** fetch com timeout — sem isso um poll/POST pendurado trava "Analisando…" pra sempre. */
async function fetchWithTimeout(url, options = {}, timeoutMs = 15000) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        return await fetch(url, { ...options, signal: controller.signal });
    } finally {
        clearTimeout(timer);
    }
}

function isAbortError(error) {
    return (
        error?.name === "AbortError" ||
        (typeof DOMException !== "undefined" &&
            error instanceof DOMException &&
            error.name === "AbortError")
    );
}

/** Catálogo + default do modelo usado no suggest (OpenRouter). */
export const getSuggestModels = async (token) => {
    try {
        const response = await fetch(BOT_OPS_CONFIG_SUGGEST_MODELS_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao listar modelos de sugestão",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

/** Formata custo OpenRouter (USD) para exibição. */
export function formatSuggestCostUsd(costUsd) {
    if (costUsd == null || costUsd === "") return null;
    const n = Number(costUsd);
    if (!Number.isFinite(n)) return null;
    if (n === 0) return "$0.00";
    if (n < 0.01) return `$${n.toFixed(4)}`;
    return `$${n.toFixed(4)}`;
}

/** Enfileira job (202) e faz poll até completed/failed — evita 504 do Cloudflare ~15s. */
export const suggestConfig = async (
    token,
    {
        problem,
        base_version_id,
        model,
        pollMs = 1500,
        maxWaitMs = 120000,
        postTimeoutMs = 20000,
        pollTimeoutMs = 12000,
        onStatus,
    } = {}
) => {
    try {
        const body = { problem };
        if (base_version_id) body.base_version_id = base_version_id;
        if (model) body.model = String(model).trim();
        onStatus?.("enqueue");
        const response = await fetchWithTimeout(
            BOT_OPS_CONFIG_SUGGEST_URL,
            {
                method: "POST",
                headers: authHeaders(token),
                body: JSON.stringify(body),
            },
            postTimeoutMs
        );
        let data;
        try {
            data = await response.json();
        } catch (_) {
            return {
                type: "error",
                message: "Resposta inválida ao pedir sugestões. Tente de novo.",
            };
        }
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao pedir sugestões de configuração",
            };
        }

        // Modo sync (CI) ou resposta já pronta
        if (data.status === "completed" || (data.ok && Array.isArray(data.patches) && !data.job_id)) {
            return data;
        }

        const jobId = data.job_id;
        if (!jobId) {
            return data;
        }

        onStatus?.(data.status || "queued");
        const deadline = Date.now() + maxWaitMs;
        while (Date.now() < deadline) {
            await sleep(pollMs);
            let pollRes;
            let pollData;
            try {
                pollRes = await fetchWithTimeout(
                    botOpsConfigSuggestJobUrl(jobId),
                    {
                        method: "GET",
                        headers: authHeaders(token),
                    },
                    pollTimeoutMs
                );
                pollData = await pollRes.json();
            } catch (_) {
                // Poll transitório (rede / timeout / 504 CF) — o worker segue no backend.
                onStatus?.("retry");
                continue;
            }
            if (!pollRes.ok) {
                return {
                    type: "error",
                    message:
                        pollData.message ||
                        pollData.error ||
                        "Erro ao consultar status da sugestão",
                };
            }
            onStatus?.(pollData.status || "running");
            if (pollData.status === "completed") {
                return pollData;
            }
            if (pollData.status === "failed") {
                return {
                    type: "error",
                    message: pollData.error || "Falha ao gerar sugestões",
                    job_id: jobId,
                };
            }
        }

        return {
            type: "error",
            message:
                "A análise está demorando mais que o esperado. O job pode ter travado — tente de novo.",
            job_id: jobId,
        };
    } catch (error) {
        return { type: "error", message: suggestFetchErrorMessage(error) };
    }
};

export const getSandboxSession = async (token) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_SESSION_URL, {
            method: "GET",
            headers: sandboxHeaders(token),
        });
        if (response.status === 200) {
            const text = await response.text();
            if (!text || text === "null") return null;
            return JSON.parse(text);
        }
        const data = await response.json();
        return { type: "error", message: data.message || "Erro ao ler sessão sandbox" };
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const createSandboxSession = async (token) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_SESSION_URL, {
            method: "POST",
            headers: sandboxHeaders(token),
            body: "{}",
        });
        const data = await response.json();
        if (!response.ok) {
            return { type: "error", message: data.message || "Erro ao criar sessão sandbox" };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const resetSandboxSession = async (token) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_SESSION_RESET_URL, {
            method: "POST",
            headers: sandboxHeaders(token),
            body: "{}",
        });
        const data = await response.json();
        if (!response.ok) {
            return { type: "error", message: data.message || "Erro ao resetar sandbox" };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const sendSandboxMessage = async (token, content) => {
    try {
        const response = await fetch(BOT_OPS_SANDBOX_MESSAGES_URL, {
            method: "POST",
            headers: sandboxHeaders(token),
            body: JSON.stringify({ content }),
        });
        const data = await response.json();
        if (!response.ok) {
            return { type: "error", message: data.message || "Erro ao enviar" };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

/**
 * Trilha do turno da conversa sandbox.
 *
 * Diagnóstico best-effort: ausência do endpoint, falha temporária do n8n/Redis
 * (502/503) ou id inválido → `{ type: "unavailable" }` (aviso calmo + retry).
 * Só erros de rede/cliente inesperados viram `{ type: "error" }` com toast.
 */
export const getSandboxTrace = async (token, conversationId, afterTs) => {
    try {
        const id = conversationId == null ? "" : String(conversationId).trim();
        // Mesma regra do backend: só id numérico Chatwoot — evita 400 ruidoso.
        if (!/^\d+$/.test(id)) {
            return { type: "unavailable" };
        }

        const params = new URLSearchParams();
        params.set("conversation_id", id);
        if (afterTs) {
            params.set("after_ts", String(afterTs));
        }
        const response = await fetchWithTimeout(
            `${BOT_OPS_SANDBOX_TRACE_URL}?${params}`,
            {
                method: "GET",
                headers: sandboxHeaders(token),
            },
            SANDBOX_POLL_TIMEOUT_MS
        );

        // 404/501 = rota ainda não existe; 502/503 = n8n/Redis intermitente.
        if ([404, 501, 502, 503].includes(response.status)) {
            return { type: "unavailable" };
        }

        const text = await response.text();
        let data = null;
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            // Rota inexistente atrás de proxy costuma responder HTML, não JSON
            return response.ok
                ? { type: "unavailable" }
                : { type: "error", message: "Resposta inválida da trilha do turno" };
        }

        if (!response.ok) {
            const msg = data?.message || data?.error || "Erro ao ler a trilha do turno";
            // Backend devolve 503 com esta mensagem; se algum proxy mudar o status,
            // ainda tratamos como indisponibilidade temporária.
            if (/trilha do turno indispon/i.test(String(msg))) {
                return { type: "unavailable" };
            }
            return { type: "error", message: msg };
        }
        return data;
    } catch (error) {
        // Timeout/abort: aviso calmo + retry — não toast de erro a cada ciclo.
        if (isAbortError(error)) {
            return { type: "unavailable" };
        }
        return { type: "error", message: error.message };
    }
};

export const listSandboxMessages = async (token, afterId) => {
    try {
        const q = afterId != null ? `?after_id=${encodeURIComponent(afterId)}` : "";
        const response = await fetchWithTimeout(
            `${BOT_OPS_SANDBOX_MESSAGES_URL}${q}`,
            {
                method: "GET",
                headers: sandboxHeaders(token),
            },
            SANDBOX_POLL_TIMEOUT_MS
        );
        const data = await response.json();
        if (!response.ok) {
            return { type: "error", message: data.message || "Erro ao listar mensagens" };
        }
        return data;
    } catch (error) {
        if (isAbortError(error)) {
            return { type: "error", message: "Tempo esgotado ao listar mensagens" };
        }
        return { type: "error", message: error.message };
    }
};

export const getPromptfooSuite = async (token) => {
    try {
        const response = await fetch(BOT_OPS_PROMPTFOO_SUITE_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler suíte promptfoo",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const putPromptfooSuite = async (token, suite) => {
    try {
        const response = await fetch(BOT_OPS_PROMPTFOO_SUITE_URL, {
            method: "PUT",
            headers: authHeaders(token),
            body: JSON.stringify(suite),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao salvar suíte promptfoo",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getPromptfooAsserts = async (token) => {
    try {
        const response = await fetch(BOT_OPS_PROMPTFOO_ASSERTS_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler asserts promptfoo",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getPromptfooModels = async (token) => {
    try {
        const response = await fetch(BOT_OPS_PROMPTFOO_MODELS_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler modelos recomendados",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const listPromptfooRuns = async (token) => {
    try {
        const response = await fetch(BOT_OPS_PROMPTFOO_RUNS_URL, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao listar execuções promptfoo",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const getPromptfooRun = async (token, id) => {
    try {
        const response = await fetch(`${BOT_OPS_PROMPTFOO_RUNS_URL}/${encodeURIComponent(id)}`, {
            method: "GET",
            headers: authHeaders(token),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao ler execução promptfoo",
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const postPromptfooRun = async (token, body = {}) => {
    try {
        const response = await fetch(BOT_OPS_PROMPTFOO_RUNS_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body && typeof body === "object" ? body : {}),
        });
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao iniciar execução promptfoo",
                status: response.status,
            };
        }
        return data;
    } catch (error) {
        return { type: "error", message: error.message };
    }
};

export const refreshPromptfooRun = async (token, id) => {
    try {
        const response = await fetchWithTimeout(
            `${BOT_OPS_PROMPTFOO_RUNS_URL}/${encodeURIComponent(id)}/refresh`,
            {
                method: "POST",
                headers: authHeaders(token),
                body: "{}",
            },
            SANDBOX_POLL_TIMEOUT_MS
        );
        const data = await response.json();
        if (!response.ok) {
            return {
                type: "error",
                message: data.message || data.error || "Erro ao atualizar execução promptfoo",
            };
        }
        return data;
    } catch (error) {
        if (isAbortError(error)) {
            return { type: "error", message: "Tempo esgotado ao atualizar execução" };
        }
        return { type: "error", message: error.message };
    }
};
